import "./OurMedicalTeam.module.css";
import Header from "@/reusable_sections/Header";
import TheHeartsBehindTheCare from "./sections/TheHeartsBehindTheCare";
import MeetOurExperts from "./sections/MeetOurExperts";
import Footer from "@/reusable_sections/Footer";
export default function OurMedicalTeamPage() {
  return <div>
      <Header />
      <TheHeartsBehindTheCare />
      <MeetOurExperts />
      <Footer />
    </div>;
}